export default __webpack_public_path__ + "static/media/assist.84897be2.svg";